import { Controller } from "@hotwired/stimulus"

// Live preview of SEO title/description format while editing short SEO fields.
export default class extends Controller {
  static targets = ["input", "preview", "titleInput", "professionSelect"]

  static values = {
    template: String,
    emptyPlaceholder: String,
    useTitleFallback: { type: Boolean, default: false },
    useProfessionFallback: { type: Boolean, default: false },
    professionFallbackTemplate: String,
    professionLabels: Object
  }

  connect () {
    this.update()
  }

  update () {
    if (!this.hasPreviewTarget || !this.hasInputTarget) return

    let value = this.inputTarget.value.trim()

    if (!value && this.useTitleFallbackValue && this.hasTitleInputTarget) {
      value = this.titleInputTarget.value.trim()
    }

    if (!value && this.useProfessionFallbackValue) {
      const professions = this.selectedProfessionLabels()
      if (professions.length > 0) {
        value = this.interpolate(this.professionFallbackTemplateValue, {
          target_professions: professions.join(" / ")
        })
      }
    }

    if (!value) {
      value = this.emptyPlaceholderValue
    }

    this.previewTarget.textContent = this.interpolate(this.templateValue, { value })
  }

  selectedProfessionLabels () {
    if (!this.hasProfessionSelectTarget) return []

    const labels = this.professionLabelsValue || {}

    return Array.from(this.professionSelectTarget.selectedOptions)
      .map((option) => labels[option.value] || option.textContent.trim())
      .filter(Boolean)
  }

  interpolate (template, values) {
    return Object.entries(values).reduce(
      (text, [key, value]) => text.replaceAll(`%{${key}}`, value),
      template
    )
  }
}
